module.exports = __webpack_public_path__ + "media/fonts/slick-c94f7671.ttf";